import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import { Button, Divider, Menu, MenuItem, Typography } from '@mui/material';
import "./styles.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import Acessibilidade from '../../components/Accessibility';
import DrawerLogin from '../../components/DrawerLogin';
import { sxAppBar, sxAppBarContrast, sxDrawer, sxDrawerContrast } from './sxProps';
import Search from '../../components/Search';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';

const HeaderLogin: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState<boolean>(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
    setSearchValue('')
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [searchValue, setSearchValue] = useState<string>('')

  const handleSetSearchValue = (value?: string): void => {
    var search = value ? value : ''
    setSearchValue(search);
  }

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openLink = (option: string, searchValue?: string): void => {
    switch (option) {
      case 'institucional':
        window.open('https://www.unimedcampinas.com.br/institucional/sobre-a-unimed', '_blank');
        break;
      case 'informativoComunicados':
        window.open('https://www.unimedcampinas.com.br/noticias', '_blank');
        break;
      case 'ouvidoria':
        window.open('https://www.unimedcampinas.com.br/autoatendimento/ouvidoria', '_blank');
        break;
      case 'clientes':
        window.open('https://www.unimedcampinas.com.br/canaldocliente', '_blank');
        break;
      case 'empresaClientes':
        window.open('https://spmweb.unimedcampinas.com.br/acesso/login/', '_blank');
        break;
      case 'medicosCooperados':
        window.open('https://wws2.unimedcampinas.com.br/LoginUnimed.aspx?PaginaRetorno=xEtrl2BPmxFYxd2Wnf4PthlZ5Fi7qKD4Tx9R44ShRlOfD4ep/8ydsEKP6+o2IgGPwIDtrVoam6O427EBwjJJjP5cryQaTUOvXqEqYelpje41el5pJqSPRDbAZqgwDu79', '_blank');
        break;
      case 'servicosCredenciados':
        window.open('https://wws2.unimedcampinas.com.br/Credenciados/', '_blank');
        break;
      case 'colaboradoresUnimed':
        window.open('https://wws2.unimedcampinas.com.br/Funcionario/', '_blank');
        break;
      case 'fornecedoresOnline':
        window.open('https://wws2.unimedcampinas.com.br/ConnectMVC/login/GetAccess?pSist=OPME&amp;returnUrl=%2Fopmemvc', '_blank');
        break;
      case 'res':
        window.open('https://wws3.unimedcampinas.com.br/RES', '_blank');
        break;
      case 'aprovadorEletronico':
        window.open('https://wws2.unimedcampinas.com.br/Aprovador', '_blank');
        break;
      case 'pesquisa':
        window.open(`https://www.unimedcampinas.com.br/busca?Pesquisa=${searchValue?.replace(/ /g, '+')}`, '_blank');
        break;

      default:
        break;
    }
  }

  const { contrastMode, contrastStyle, textStyleAccessibility } = useAccessibility();

  return (
    <div style={contrastStyle} className='container-header-login'>
      <AppBar sx={contrastMode ? sxAppBarContrast : sxAppBar} position="fixed">
        <Toolbar>
          <div className='container-botao-menu-drawer'>
            <Search openLink={openLink} searchValue={searchValue} setSearchValue={handleSetSearchValue} />
            <IconButton
              edge="start"
              onClick={handleDrawerToggle}
            >
              <FontAwesomeIcon style={contrastStyle} icon={faBars} />
            </IconButton>
          </div>
          <div className='menu-login-container'>
            <div className='container-headerLogin-align-center'>
              <div className='container-headerlogin-menu-options'>
                <Button onClick={() => openLink('institucional')}>
                  <Typography style={textStyleAccessibility} className='menu-login-text'>Institucional</Typography>
                </Button>
                <Button>
                  <Typography style={textStyleAccessibility} onClick={() => openLink('informativoComunicados')} className='menu-login-text'>Informativos e Comunicados</Typography>
                </Button>
                <Button>
                  <Typography style={textStyleAccessibility} onClick={() => openLink('ouvidoria')} className='menu-login-text'>Ouvidoria</Typography>
                </Button>

                <div className='container-headerLogin-align-center'>
                  <Button
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                    size='small'
                    endIcon={<FontAwesomeIcon className='header-login-icon-down' icon={faChevronDown} />}
                  >
                    <Typography style={textStyleAccessibility} className='menu-login-text'>Canais</Typography>
                  </Button>
                  <Menu
                                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                                    MenuListProps={{
                                        'aria-labelledby': 'basic-button',
                                    }}
                  >
                    <MenuItem style={textStyleAccessibility} onClick={() => openLink('clientes')} className='menu-login-text menu-login-options-item'>Clientes</MenuItem>
                    <MenuItem style={textStyleAccessibility} onClick={() => openLink('empresaClientes')} className='menu-login-text menu-login-options-item'>Empresas Clientes </MenuItem>
                    <MenuItem style={textStyleAccessibility} onClick={() => openLink('medicosCooperados')} className='menu-login-text menu-login-options-item'>Médicos Cooperados</MenuItem>
                    <MenuItem style={textStyleAccessibility} onClick={() => openLink('servicosCredenciados')} className='menu-login-text menu-login-options-item'>Serviços Credenciados</MenuItem>
                    <MenuItem style={textStyleAccessibility} onClick={() => openLink('colaboradoresUnimed')} className='menu-login-text menu-login-options-item'>Colaboradores Unimed</MenuItem>
                    <MenuItem style={textStyleAccessibility} onClick={() => openLink('fornecedoresOnline')} className='menu-login-text menu-login-options-item'>Fornecedores Online</MenuItem>
                    <MenuItem style={textStyleAccessibility} onClick={() => openLink('res')} className='menu-login-text menu-login-options-item'>RES</MenuItem>
                    <MenuItem style={textStyleAccessibility} onClick={() => openLink('aprovadorEletronico')} className='menu-login-text menu-login-options-item'>Aprovador Eletrónico</MenuItem>
                  </Menu>
                </div>
              </div>
            </div>
            <div className='container-botoes-header-login'>
              <Search openLink={openLink} setSearchValue={handleSetSearchValue} searchValue={searchValue} />
              <Acessibilidade />
            </div>
          </div>
        </Toolbar>
        {contrastMode && <Divider color='white' />}
      </AppBar>
      <Drawer
        variant="temporary"
        anchor={'right'}
        open={mobileOpen}
        style={contrastStyle}
        PaperProps={contrastMode ? sxDrawerContrast : sxDrawer}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <DrawerLogin openLink={openLink} handleDrawerToggle={handleDrawerToggle} searchValue={searchValue} setSearchValue={handleSetSearchValue} />
      </Drawer>
    </div>
  );
};

export default HeaderLogin;
